import Link from "@app/_components/Link";
import { getPageById } from "@server/requests/contentful/getPageById";
import type { PropsWithChildren } from "react";

import type { Market } from "@features/market/config/i18n-config";

export default async function RichTextAsyncLink({
  id,
  children,
  market,
}: PropsWithChildren<{
  id?: string;
  market: Market;
}>) {
  if (!id) {
    return null;
  }
  const page = await getPageById({
    id,
    locale: market.contentfulLocale,
  });
  return (
    <Link locale={market.siteLocale} href={page?.slug}>
      {children}
    </Link>
  );
}
